/* eslint-disable quotes */
/* eslint-disable semi */
/* eslint-disable indent */
let wx = require('weixin-js-sdk')
    /*
    微信支付方法
    获取微信加签信息
    @param{data}:获取的微信加签
    @param{cb}:成功回调
    */
let wxShare = (config, shareData, WXShareSuccess) => {
    console.log('wxshare', config, shareData)
    wx.config({
        debug: true,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['onMenuShareAppMessage', 'updateAppMessageShareData', 'onMenuShareTimeline', 'updateTimelineShareData']
    })
    wx.ready(function() {
        console.log('ready=执行')
        wx.onMenuShareAppMessage({
            title: shareData.title, // 分享标题
            desc: shareData.desc, // 分享描述
            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.imgUrl, // 分享图标
            success: function(res) {
                WXShareSuccess()
                alert("123123")
            }
        })
        wx.updateAppMessageShareData({
            title: shareData.title, // 分享标题
            desc: shareData.desc, // 分享描述
            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.imgUrl, // 分享图标
            success: function(res) {
                WXShareSuccess()
                alert("123123")
            }
        })
        wx.onMenuShareTimeline({
            title: shareData.title, // 分享标题
            link: shareData.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.icon, // 分享图标
            success: function(res) {
                WXShareSuccess()
            }
        })
        wx.updateTimelineShareData({
            title: shareData.title, // 分享标题
            link: shareData.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.icon, // 分享图标
            success: function(res) {
                WXShareSuccess()
            }
        })
    })
    wx.error((err) => {
        console.log("error=>", err)
    })
}
export default wxShare